import { PublicModulesRouteMap } from '@/new-router/public-modules'

const engineList = () => import('@/views/Transmission/engineList')
const lineConfig = () => import('@/views/Transmission/lineConfig')
const asperaAccountConfig = () => import('@/views/Transmission/asperaAccountConfig')
const addEngineList = () => import('@/views/Transmission/components/addEngineList')

const Home = () => import('@/views/Home/home')

/**
* hidden: true                   是否显示在侧栏上
  nocache: true                  组件将不keep-alive
* meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
  }
**/

export default [
  {
    path: '/transmission',
    name: 'transmission',
    component: Home,
    meta: {
      title: '传输配置',
      icon: 'icon-storage',
      showSubiems: false,
      sort: 9,
      modules: 'transmission',
      permission: 'transfer:root',
    },
    children: [
      {
        path: 'engineList',
        name: 'engineList',
        component: engineList,
        meta: {
          title: '引擎列表',
          active: ['engineList'],
          permission: 'transfer:engine',
          belong: [
            PublicModulesRouteMap.PublicModules,
            PublicModulesRouteMap.TransferConfiguration,
          ],
        },
      },
      {
        path: 'engineList/:id',
        name: 'addEngineList',
        component: addEngineList,
        hidden: true,
        meta: {
          title: '新增引擎',
          nocache: true,
        },
      },
      {
        path: 'lineConfig',
        name: 'lineConfig',
        component: lineConfig,
        meta: {
          title: '线路配置',
          active: ['lineConfig'],
          permission: 'transfer:engine:line',
          belong: [
            PublicModulesRouteMap.PublicModules,
            PublicModulesRouteMap.TransferConfiguration,
          ],
        },
      },
      {
        path: 'asperaAccountConfig',
        name: 'asperaAccountConfig',
        component: asperaAccountConfig,
        meta: {
          title: 'Aspera账户配置',
          active: ['asperaAccountConfig'],
          permission: 'transfer:aspera',
          belong: [PublicModulesRouteMap.PublicModules, PublicModulesRouteMap.TransferConfiguration],
        },
      },
    ],
  },
]
